import {
  CircularProgress,
  List,
  ListItem,
  ListItemButton,
  Menu,
} from "@mui/material";
import { useTestStore } from "../../../hooks/store";
import Styles from "../TestComponentStyles.module.css";
import { useEffect, useState } from "react";
import HelpOutlineRoundedIcon from "@mui/icons-material/HelpOutlineRounded";
import { useSearchParams } from "react-router";

import { endpoints } from "../../../utils/config";
import { Img } from "react-image";
import { testType as testTypeHelper } from "../../../utils/testHelper";
import ExpandableText from "../ExpandableText";

export function TestQuestion({ questionData }) {
  const testStore = useTestStore();
  const { image_src, text, error_text, answers, id } = questionData;
  const { testId, submitAnswer, userAnswers, questionList, testType } =
    testStore;
  const [updateAnswers, setAnswersUpdate] = useState(false);
  const [wrongQuestionAnchor, setWrongQuestionAnchor] = useState(null);
  const [SearchParams, setParams] = useSearchParams();
  const [answerSending, setAnswerSending] = useState(false);
  const errorExplOpen = Boolean(wrongQuestionAnchor);

  console.log(testType);

  const handleNext = () => {
    const nextQuestionId = questionList.indexOf(questionData) + 1;
    const nextQuestion = questionList[nextQuestionId] || questionList[0];

    setParams({ ...SearchParams, question: nextQuestion.id });
  };

  const handleFinish = () => {
    testStore.finishTest();
  };

  const explClick = (event) => {
    setWrongQuestionAnchor(event.currentTarget);
  };

  const explClose = () => {
    setWrongQuestionAnchor(null);
  };

  const handleAnswerClick = async (e) => {
    setAnswerSending(true);
    const answerId = e.target.id;
    const questionId = id;

    const answerStatus = await submitAnswer(questionId, answerId, testId);

    if (!answerStatus.is_right && testType.type !== testTypeHelper.exam.type) {
      setWrongQuestionAnchor(document.getElementById(answerStatus.userAnswer));
    }
    setAnswerSending(false);
  };

  const renderAnswerList = () => {
    const userAnswer = userAnswers.find((item) => item.questionId == id);

    if (userAnswer) {
      if (testType.type !== testTypeHelper.exam.type) {
        return answers.map((item, index) => {
          const itemName = `${++index}. ${item.text}`;
          if (userAnswer.correct == item.id) {
            return (
              <ListItem>
                <ListItemButton
                  id={item.id}
                  className={`${Styles.question_answer} ${Styles.answer_correct}`}>
                  {itemName}
                </ListItemButton>
              </ListItem>
            );
          } else if (!userAnswer.is_right && userAnswer.userAnswer == item.id) {
            return (
              <ListItem>
                <ListItemButton
                  style={{ justifyContent: "space-between" }}
                  id={item.id}
                  onClick={explClick}
                  className={`${Styles.question_answer} ${Styles.answer_wrong}`}>
                  {index + ". " + item.text}
                  <HelpOutlineRoundedIcon
                    fontSize="small"
                    style={{ color: "var(--bckg-accent)" }}
                  />
                </ListItemButton>
              </ListItem>
            );
          } else {
            return (
              <ListItem>
                <ListItemButton
                  disabled
                  id={item.id}
                  className={`${Styles.question_answer}`}>
                  {itemName}
                </ListItemButton>
              </ListItem>
            );
          }
        });
      } else {
        return answers.map((item, index) => {
          const itemName = `${++index}. ${item.text}`;
          if (userAnswer.userAnswer === item.id) {
            return (
              <ListItem>
                <ListItemButton
                  id={item.id}
                  className={`${Styles.question_answer} `}>
                  {itemName}
                </ListItemButton>
              </ListItem>
            );
          } else {
            return (
              <ListItem>
                <ListItemButton
                  disabled
                  id={item.id}
                  className={`${Styles.question_answer}`}>
                  {itemName}
                </ListItemButton>
              </ListItem>
            );
          }
        });
      }
    } else {
      return answers.map((item, index) => (
        <ListItem>
          <ListItemButton
            disabled={answerSending}
            color="success"
            id={item.id}
            onClick={handleAnswerClick}
            className={`${Styles.question_answer}`}>
            {`${++index}. ${item.text}`}
          </ListItemButton>
        </ListItem>
      ));
    }
  };

  useEffect(() => {
    setAnswersUpdate(true);
  }, [userAnswers]);

  return (
    <div className={Styles.question}>
      <Img
        // loading="lazy"
        loading={true}
        loader={
          <div
            className={Styles.question_image}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}>
            <CircularProgress sx={{ color: "var(--bckg-accent)" }} />
          </div>
        }
        src={[
          endpoints.image + "/test/" + image_src,
          endpoints.image + "/test/" + "NoImage.png",
        ]}
        onLoad={(e) => {
          console.log("Loaded", e.target);
          e.target.classList.add("question_image_loaded");
        }}
        alt={image_src}
        className={Styles.question_image}
      />

      {/* <img
        src={endpoints.image + "/" + image_src}
        alt=""
        onError={(e) => {
          // e.currentTarget.onError = e.currentTarget.src = ""; // prevents looping
        }}
        className={Styles.question_image}
      /> */}
      {/* <div className={Styles.question_text}>
        <p>{text}</p>
      </div> */}
      <ExpandableText text={text} />
      <List
        sx={{
          maxWidth: 500,
          width: "100%",
          paddingTop: 0,
          overflowY: "visible",
        }}
        className={Styles.question_answer_list}>
        {updateAnswers && renderAnswerList()}

        {/* <div
          className={`${Styles.question_answer_loader} ${
            answerSending && Styles.question_answer_loader_append
          }`}>
          <CircularProgress
            sx={{ color: "var(--bckg-accent)" }}
            className={`${
              answerSending && Styles.question_answer_loader_append
            }`}
          />
        </div> */}
      </List>

      <div className={Styles.question_actions}>
        {userAnswers.length == questionList.length &&
        testStore.testType.type !== testTypeHelper.preview.type ? (
          <button onClick={handleFinish}>Завершить</button>
        ) : (
          testStore.userAnswers.find(
            (answer) => answer.questionId == SearchParams.get("question"),
          ) && <button onClick={handleNext}>Далее</button>
        )}
      </div>
      <Menu
        className={Styles.question_expl_menu}
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={wrongQuestionAnchor}
        open={errorExplOpen}
        onClose={explClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "botom",
          horizontal: "left",
        }}>
        <div className={Styles.question_expl}>
          <p>Объяснение</p>
          <span style={{ width: `${!error_text && "max-content"}` }}>
            {error_text || "Пояснение не добавлено"}
          </span>
        </div>
      </Menu>
    </div>
  );
}
